import { createReminderInitialValues } from '@src/shared/features/reminders/dialogs/create-or-edit-reminder/schema';
import { array, object, string, mixed } from 'yup';

import type { TReminderTemplate } from '@src/shared/types/reminder-template';

const createCommonBulkReminderInitialValues = () => {
  const {
    view,
    variables,
    attachments,
    name,
    content,
    subject,
    notification_channel,
    date,
  } = createReminderInitialValues({
    reminder: undefined,
    reminderTemplate: undefined,
  });
  return {
    view,
    variables,
    attachments,
    name,
    content,
    subject,
    notification_channel,
    date,
    template: undefined as TReminderTemplate | undefined,
  };
};

export const createBulkLeadReminderInitialValues = () =>
  createCommonBulkReminderInitialValues();
export const createBulkStudentReminderInitialValues = () =>
  createCommonBulkReminderInitialValues();
export const createBulkStageReminderInitialValues = () =>
  createCommonBulkReminderInitialValues();

/** @deprecated use entity specific initial values instead */
export const createBulkReminderInitialValues = () =>
  createCommonBulkReminderInitialValues();

const commonBulkReminderFormSchema = object().shape({
  attachments: array().of(mixed()),
  name: string().required('Name is required'),
  content: string().required('Content is required'),
  subject: string().nullable(),
  view: mixed().nullable(),
  notification_channel: string().required('Notification channel is required'),
  date: string().required('Date is required'),
  variables: object(),
  template: mixed().nullable(),
});

export const bulkLeadReminderFormSchema = commonBulkReminderFormSchema.shape({
  subject: string().when('notification_channel', {
    is: (val: string) => val === 'EMAIL',
    then: (schema) => schema.required('Subject is required for emails'),
    otherwise: (schema) => schema.nullable(),
  }),
  view: mixed().nullable(),
});

export const bulkStudentReminderFormSchema = commonBulkReminderFormSchema;
export const bulkStageReminderFormSchema = commonBulkReminderFormSchema;

export type TBulkReminderFormValues = ReturnType<
  typeof createBulkReminderInitialValues
>;
